<div class="flex-center fl-col border border-[#DCDCDC] bg-white rounded-2xl py-[24px] px-[28px]">
    <div class="payment-success-animation">
        <ng-lottie width="142px" height="142px" [options]="questionContentAnimationOptions"></ng-lottie>
    </div>  
        <div class="text-base text-[#18191C] font-semibold">{{ text }} </div>
</div>